import { render, staticRenderFns } from "./ProposalInfoItem.vue?vue&type=template&id=0cd0f7fa&scoped=true&"
import script from "./ProposalInfoItem.vue?vue&type=script&lang=js&"
export * from "./ProposalInfoItem.vue?vue&type=script&lang=js&"
import style0 from "./ProposalInfoItem.vue?vue&type=style&index=0&id=0cd0f7fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd0f7fa",
  null
  
)

export default component.exports